import ConfirmDialog from '../components/confirm-dialog'
import { useDeleteModel } from '../store/use-delete-model'

interface TDeleteModel {
    loading: boolean
}

const DeleteModel = ({ loading = false }: TDeleteModel) => {
    const { onCloseDeletePopup, initialValues } = useDeleteModel()

    return (
        <ConfirmDialog
            tone={initialValues.tone ?? "danger"}
            title={initialValues.title ?? "Delete this item?"}
            description={initialValues.description ?? "This action can't be undone."}
            detail={initialValues.detail}
            confirmLabel={initialValues.confirmLabel ?? "Delete"}
            loading={loading}
            onConfirm={initialValues.onClick}
            onCancel={onCloseDeletePopup}
        />
    )
}

export default DeleteModel
